var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommFields = function SvgCommFields(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "comm_fields_svg2__a",
    x1: 27.72,
    x2: 177.3,
    y1: 165.29,
    y2: 19.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#comm_fields_svg2__a",
    id: "comm_fields_svg2__c",
    x1: 15.62,
    x2: 165.2,
    y1: 152.84,
    y2: 7.48
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#comm_fields_svg2__a",
    id: "comm_fields_svg2__d",
    x1: 31.29,
    x2: 180.87,
    y1: 168.96,
    y2: 23.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#comm_fields_svg2__a",
    id: "comm_fields_svg2__e",
    x1: 46.97,
    x2: 196.55,
    y1: 185.1,
    y2: 39.73
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M188.55 14.94H79.06c-6.26 0-11.34 5.08-11.34 11.34v42.59H11.34C5.08 68.89.01 73.96 0 80.21v71.93c.01 6.26 5.08 11.33 11.34 11.34h21.63l-.53 17.69c-.05 1.4.67 2.71 1.87 3.43 1.24.61 2.68.61 3.92 0l38.18-21.21h45.31c6.26 0 11.34-5.08 11.34-11.34v-33.84h6.55l30.21 21.3c1.22.73 2.72.83 4.03.27a3.83 3.83 0 0 0 2.23-3.45v-18.11h12.59c6.26 0 11.34-5.08 11.34-11.34v-80.6c0-6.26-5.08-11.34-11.34-11.34h-.11Zm-63.29 137.21a3.54 3.54 0 0 1-3.54 3.54H75.3c-.66 0-1.31.17-1.89.49l-33.04 18.36.45-14.84c.02-1.06-.4-2.09-1.16-2.83a3.9 3.9 0 0 0-2.81-1.18H11.34a3.54 3.54 0 0 1-3.54-3.54V80.22a3.56 3.56 0 0 1 3.54-3.54h56.38v30.21c0 6.26 5.08 11.34 11.34 11.34h46.2v33.93Zm66.83-45.27a3.54 3.54 0 0 1-3.54 3.54h-16.48c-2.15 0-3.9 1.75-3.9 3.9v14.48l-25.06-17.67c-.65-.46-1.43-.71-2.23-.71H79.06a3.54 3.54 0 0 1-3.54-3.54v-80.6a3.54 3.54 0 0 1 3.45-3.63h109.58a3.54 3.54 0 0 1 3.54 3.54z",
    style: {
      fill: "url(#comm_fields_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.74 59.12c-4.47 0-8.09 3.62-8.09 8.09s3.62 8.09 8.09 8.09 8.09-3.62 8.09-8.09-3.62-8.09-8.09-8.09",
    style: {
      fill: "url(#comm_fields_svg2__c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.02 59.12c-4.47-.01-8.1 3.6-8.11 8.06-.01 4.47 3.6 8.1 8.06 8.11 4.47.01 8.1-3.6 8.11-8.06v-.02c.01-4.45-3.59-8.07-8.04-8.09z",
    style: {
      fill: "url(#comm_fields_svg2__d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.3 59.12c-4.47-.01-8.1 3.6-8.11 8.06s3.6 8.1 8.06 8.11c4.47.01 8.1-3.6 8.11-8.06v-.02c.01-4.45-3.59-8.07-8.04-8.09z",
    style: {
      fill: "url(#comm_fields_svg2__e)",
      strokeWidth: 0
    }
  }));
};
export default SvgCommFields;